<div class="resources-card" *ngIf="sourceData[indexData]">
    <img class="card-image" src="{{ information.img }}" alt="" />
    <div class="data-access">
        {{ sourceData[indexData]['document_meta']?.['Disclaimer']['Label'] }}
    </div>
    <h3>
        {{
            sourceData[indexData]['document_meta']?.['ShortDescription'].length > 50
                ? sourceData[indexData]['document_meta']?.['ShortDescription'].substring(0, 50) +
                  '...'
                : sourceData[indexData]['document_meta']?.['ShortDescription']
        }}
    </h3>
    <div class="link-container">
        <div class="icon-link-container">
            <img src="{{ information.icon }}" alt="" />
            <a rel="noopener" [href]="sourceData[indexData]['web_url']" target="_blank">
                {{ sourceData[indexData]['name'] }}
            </a>
        </div>
        <a rel="noopener" [href]="sourceData[indexData]['web_url']" target="_blank"
            ><img src="../../../../assets/icons/arrow-right.svg" alt=""
        /></a>
    </div>
</div>
